<template>
  <section class="download">
  </section>
</template>
<script>
export default {
  name: '',
  data() {
    return {
      MarketUrl: 'http://sj.qq.com/myapp/detail.htm?apkName=com.haidu.academy',
      AndroidApkUrl: '',
      AppStoreUrl: 'https://itunes.apple.com/us/app/%E6%B5%B7%E6%B8%A1%E5%AD%A6%E9%99%A2/id1249979481?ls=1&mt=8'
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.service.getAppVersion().then(result => {
        if (result.success) {
          this.MarketUrl = result.data.MarketUrl;
          this.AndroidApkUrl = result.data.AndroidApkUrl;
          this.AppStoreUrl = result.data.AppStoreUrl;
          this.getDownloadUrlByDevice();
        }
      }).catch(error => {
        this.getDownloadUrlByDevice();
      });
    },
    isAndroid() {
      var u = navigator.userAgent;
      return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
    },
    isIOS() {
      var u = navigator.userAgent;
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    },
    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == 'micromessenger';
    },
    getDownloadUrlByDevice() {
      if (this.isAndroid()) {
        console.log(`安卓`);
        /* if (this.isWeixin()) { //应用宝市场链接 location.href = this.MarketUrl; } else { //apk链接 location.href = this.AndroidApkUrl; }
         */
        location.href = this.MarketUrl;
      } else if (this.isIOS()) {
        console.log(`ios设备`);
        //appstore链接
        location.href = this.AppStoreUrl;
      } else {
        console.log(`其他设备`)
        location.href = this.MarketUrl;
      }
    }
  }
}

</script>
<style lang="scss" scoped>


</style>



// WEBPACK FOOTER //
// Download.vue?a21d8cd2